export default "__VITE_ASSET__zPLpWFsJ__"